module.exports = __webpack_public_path__ + "static/media/sunset.b9d8069a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/css_art/sunset.png
// module id = 112
// module chunks = 0